// import React from 'react';
// import './News.css';
// import AllIntroTemplate from "../../components/AllIntroTemplate/AllIntroTemplate.js";

// import NewsList from "../../components/NewsList/NewsList.js";
// import totalData from "../../json/data.json";

// const News = () => {
//   const data = totalData[22];
//   return (
//     <div>
//       <AllIntroTemplate image={data.Image} title={data.Title} page={totalData[0]}/>
//       <NewsList />
//     </div>
//   );
// };

// export default News;



import React, { Suspense, lazy } from 'react';
import './News.css';
import totalData from "../../json/data.json";

// Lazy load components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const NewsList = lazy(() => import("../../components/NewsList/NewsList.js"));

const News = () => {
  const data = totalData[22];

  return (
    <div>
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate image={data.Image} title={data.Title} page={totalData[0]} />
      </Suspense>

      <Suspense fallback={<p>Loading news list...</p>}>
        <NewsList />
      </Suspense>
    </div>
  );
};

export default News;
